
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"400","height":"350","viewBox":"0 0 105.833 92.604","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.347 46.031a64.023 75.01 0 0147.57-24.807 64.023 75.01 0 0147.57 24.807M5.347 46.573a64.023 75.01 0 0047.57 24.807 64.023 75.01 0 0047.57-24.807","fill":"none","stroke":"#a0a0a0","stroke-width":"8.0487933","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{staticStyle:{"-inkscape-stroke":"none"},attrs:{"d":"M68.961 46.302a16.045 16.045 0 01-16.044 16.045 16.045 16.045 0 01-16.045-16.045 16.045 16.045 0 0116.045-16.044A16.045 16.045 0 0168.96 46.302z","color":"#000","fill":"#a0a0a0"}}),_c('path',{attrs:{"d":"M7.675 88.642L95.257 1.061l2.901 2.9-87.582 87.583z","fill":"gray"}})])
          )
        }
      }
    